








































































import BaseComponent from '@/components/base-component.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import { listRuleAlterHist } from '@/services/rules-engine';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: { PermissionAuth }
})
export default class RuleViewHistTabs extends BaseComponent {
  @Prop()
  id: number;

  list = [];
  tabIndex = 0;
  panelIndex = 0;
  loading = false;

  public headers: any = [
    { text: 'Campo', value: 'nome', sortable: false },
    { text: 'Alterações', value: 'alteracao', sortable: false }
  ];

  @Watch('id', { immediate: true })
  onIdRuleChange() {
    this.tabIndex = 0;
    this.panelIndex = 0;
    if (!this.id) {
      this.list = [];
      return;
    }
    this.loading = true
    listRuleAlterHist(this.id).subscribe((list) => {
      this.list = list;
      this.loading = false;
    });
  }
}
